import React from 'react';
import {BoxBackground, CustomHeader2, CustomP, CustomP2White, Section} from "../components/Headers";
import {Col, Row, Typography} from "antd"
import {useIsMobile} from "../components/LayoutWrapper"
import {VideoCameraOutlined} from "@ant-design/icons"
import PlayerStats from '../icons/player_stats.png'
import TeamStats from '../icons/team_stats.png'

const {Title} = Typography

const StatsHeader: React.FC = () => {
    const isMobile = useIsMobile()

    return (
        <BoxBackground

            style={{
                height: 'auto',
                marginBottom: '10vh'
            }}

        >
            <Title
                style={{
                    marginTop: '100px',
                    // width: '40%',
                    textAlign: 'center'
                }}
            >
                Analyze player and team stats
            </Title>
            <CustomP

                style={{
                    marginLeft: isMobile ? undefined : '10vh',
                    marginRight: isMobile ? undefined : '10vh',
                    textAlign: 'center'
                }}

            >
                Uncover player and team performance insights with Spaik
            </CustomP>
        </BoxBackground>
    );
}

const StatsSection: React.FC = () => {
    const isMobile = useIsMobile()
    const col_span = isMobile ? 24 : 12
    return (

        <Section

        >
            <div
                style={{
                    marginLeft: isMobile ? '0vh' : '5vh',
                    marginRight: isMobile ? '0vh' : '10vh'

                }}

            >
                <CustomHeader2>
                    Stats
                </CustomHeader2>
                <CustomP2White>
                    Explore detailed football performance metrics. Spaik provides in-depth analysis to enhance your
                    understanding of the game.
                    <br/><br/>
                    Click <VideoCameraOutlined/> to watch a highlight for each stat.
                    <br/>
                    <br/>
                    <Row
                        style={{width: '100%'}}
                    >
                        <Col
                            span={col_span}
                        >
                            <img
                                style={{
                                    width: '90%',
                                    marginBottom: isMobile ? '2vh' : '0vh'
                                }}
                                src={PlayerStats}
                            />
                        </Col>
                        <Col
                            span={col_span}
                        >
                            <img
                                style={{
                                    width: '90%'
                                }}
                                src={TeamStats}
                            />
                        </Col>
                    </Row>
                </CustomP2White>

            </div>
        </Section>

    )
}


const Stats: React.FC = () => {


    return (
        <div>
            <StatsHeader/>
            <StatsSection/>
            {/*<FoundersSection/>*/}
        </div>
    );
};

export default Stats;